import React, { useEffect, useState } from "react";
import "./AllCertificates.scss";
import Label from "../../components/Label/Label";
import HeaderLogin from "../../components/HeaderLogin/HeaderLogin";
import Footer from "../../components/Footer/Footer";
import { fetchCertificateList } from "../../services/certificateApi";
import {
  formatDisplayDate,
  getApiErrorMessage,
} from "../../services/apiClient";
import { isAdminUser, isLoggedIn } from "../../util/auth";

const getUserName = (certificate) => {
  const name = [certificate.firstName, certificate.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  return name || certificate.userId || "—";
};

const isDelivered = (certificate) => {
  if (!certificate.endDate) {
    return "no";
  }

  const endDate = new Date(certificate.endDate);

  return endDate <= new Date() ? "yes" : "no";
};

const AllCertificates = () => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [certificates, setCertificates] = useState([]);
  const [loadError, setLoadError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCertificates = async () => {
      if (!isLoggedIn() || !isAdminUser()) {
        setLoadError("Admin login required to view all certificates.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setLoadError("");

      try {
        const items = await fetchCertificateList();
        setCertificates(items);
      } catch (error) {
        console.error("Failed to load certificates", error);
        setCertificates([]);
        setLoadError(
          getApiErrorMessage(
            error,
            "Failed to load certificates. Ensure you are logged in as admin.",
          ),
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadCertificates();
  }, []);

  return (
    <div className="allCertificate">
      <div className="allCertificate_inner">
        <HeaderLogin />
        <div className="centerDiv" style={{ height: dimensions.height + "px" }}>
          <div className="certificateContainer">
            <Label className="allTitle" title="All Certificates" />
            {loadError && <Label title={loadError} className="certificate_Load_Error" />}
            <div className="tab">
              <div>SL. NO</div>
              <div>User Name</div>
              <div>Certificate ID (UUID)</div>
              <div>Date of Birth</div>
              <div>Start Date</div>
              <div>End Date</div>
              <div>Delivered</div>
            </div>

            <div className="tableData">
              {isLoading ? (
                <div className="customers empty_Row">
                  <div>Loading certificates...</div>
                </div>
              ) : certificates.length === 0 ? (
                <div className="customers empty_Row">
                  <div>No certificates found.</div>
                </div>
              ) : (
                certificates.map((certificate, index) => (
                  <div className="customers" key={certificate.certificateId}>
                    <div>{index + 1}.</div>
                    <div>{getUserName(certificate)}</div>
                    <div className="certificate_Id_Cell">
                      {certificate.certificateId}
                    </div>
                    <div>{certificate.dateOfBirth || "—"}</div>
                    <div>{formatDisplayDate(certificate.startDate)}</div>
                    <div>{formatDisplayDate(certificate.endDate)}</div>
                    <div>{isDelivered(certificate)}</div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AllCertificates;
